export default "__VITE_ASSET__D7XfpuU6__"